<template>
  <div class="device-list">
    <PageHeader>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.label"
          :name="item.value"
          v-for="(item, index) in languageList"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
    </PageHeader>

    <CardContainer>
      <div style="height: 100vh">
        <div class="btn-group">
          <hl-button type="primary" @click="handleEdit" v-if="updateRole">{{
            $t('Common.edit')
          }}</hl-button>
        </div>
        <div :loading="loading" v-html="content" class="partsContent"></div>
      </div>
      <PartEdit :row="row" @refresh="refresh" v-if="visible" :visible.sync="visible" />
    </CardContainer>
  </div>
</template>

<script>
import { languageList } from '@/config/status.js'
import HlButton from '../../../components/Button'
import PartEdit from './partEdit'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'
import PageHeader from '../../../components/PageHeader'
export default {
  name: 'index',
  components: { PageHeader, HlButton, PartEdit },
  mixins: [getRoleFromPath],
  data() {
    return {
      languageList,
      row: {},
      activeName: 'zh',
      visible: false,
      content: '',
      loading: false
    }
  },
  computed: {
    /********* 权限 ***********/
    // this.role 计算属性通过mixins: [getRoleFromPath] 注入
    // 导出权限
    roleChildList() {
      return this.role.childList
    },
    // 编辑的权限
    updateRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'update')
      return val ? val.isPermission === 'Y' : false
    }
  },
  mounted() {
    this.handleClick()
  },
  methods: {
    refresh() {
      this.handleClick()
    },
    handleEdit() {
      this.visible = true
      this.row.language = this.activeName
    },
    handleClick() {
      this.loading = true
      this.$ajax
        .get(this.$api.system.detail_part_purchase, { language: this.activeName })
        .then((res) => {
          this.content = res.data
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.partsContent {
  border: 1px solid lightgray;
  height: 600px;
  margin: 24px 0;
  border-radius: 8px;
  padding: 24px;
}
</style>
